import { useInvalidateAllocations } from '@features/allocation';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { allocationTagQueries } from '../queries';
import { allocationTagService } from '../services/allocationTagService';

export function useDeleteAllocationTag() {
  const queryClient = useQueryClient();
  const invalidateAllocations = useInvalidateAllocations();

  return useMutation({
    mutationFn: (id: number) => allocationTagService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: allocationTagQueries.lists() });
      invalidateAllocations();
    },
  });
}
